import React from "react";

const Optional = ({ orderInstraction, setOrderInstraction }) => {
  return (
    <>
      {" "}
      <div>
        <div className="row my-4">
          <div className="col-md-12">
            <textarea
              className="form-control"
              cols="50"
              placeholder="Order Instructions"
              rows="4"
              value={orderInstraction}
              onChange={(e) => setOrderInstraction(e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
    </>
  );
};

export default Optional;
